@use "@styles/tokens";

@layer base-components {
    .flexLayout {
        display: flex;

        &[data-direction="column"] {
            flex-direction: column;
        }

        &[data-direction="row"] {
            flex-direction: row;
        }

        &[data-wrap] {
            flex-wrap: wrap;
        }

        &[data-align="start"] {
            align-items: flex-start;
        }

        &[data-align="center"] {
            align-items: center;
        }

        &[data-align="end"] {
            align-items: flex-end;
        }

        &[data-align="stretch"] {
            align-items: stretch;
        }

        &[data-justify="start"] {
            justify-content: flex-start;
        }

        &[data-justify="center"] {
            justify-content: center;
        }

        &[data-justify="end"] {
            justify-content: flex-end;
        }

        &[data-justify="between"] {
            justify-content: space-between;
        }

        &[data-justify="around"] {
            justify-content: space-around;
        }

        &[data-justify="evenly"] {
            justify-content: space-evenly;
        }

        @each $step in tokens.$space-steps {
            &[data-gap="#{$step}"] {
                gap: var(--space-#{$step});
            }

            &[data-padding="#{$step}"] {
                padding: var(--space-#{$step});
            }
        }

        // Separate loop so the axis-specific rules always come after every
        // `padding` shorthand rule in source order and win the cascade on
        // their axis regardless of step combination.
        @each $step in tokens.$space-steps {
            &[data-padding-inline="#{$step}"] {
                padding-inline: var(--space-#{$step});
            }

            &[data-padding-block="#{$step}"] {
                padding-block: var(--space-#{$step});
            }
        }
    }
}
